let html = `<div class="extensions__item extensions__item--screensaver selector layer--visible layer--render">
    <div class="extensions__item-imagebox">
        <img class="extensions__item-image" />
    </div>
    <div class="extensions__item-overlay">
        <div class="extensions__item-name"></div>
        <div class="extensions__item-time"></div>
    </div>
</div>`

export default html